package de.connect2x.timmy.brandings.lifetimeTheme

import androidx.compose.material3.ColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.ui.graphics.Color
import de.connect2x.trixnity.messenger.compose.view.theme.ThemeLightColorScheme

object ThemeLightColorSchemeWcImpl : ThemeLightColorScheme {
    override fun create(accentColor: Color): ColorScheme {
        return lightColorScheme(
            primary = md_theme_light_primary,
            onPrimary = md_theme_light_onPrimary,
            primaryContainer = md_theme_light_primaryContainer,
            onPrimaryContainer = md_theme_light_onPrimaryContainer,
            secondary = md_theme_light_secondary,
            onSecondary = md_theme_light_onSecondary,
            secondaryContainer = md_theme_light_secondaryContainer,
            onSecondaryContainer = md_theme_light_onSecondaryContainer,
            tertiary = md_theme_light_tertiary,
            onTertiary = md_theme_light_onTertiary,
            tertiaryContainer = md_theme_light_tertiaryContainer,
            onTertiaryContainer = md_theme_light_onTertiaryContainer,
            error = md_theme_light_error,
            onError = md_theme_light_onError,
            errorContainer = md_theme_light_errorContainer,
            onErrorContainer = md_theme_light_onErrorContainer,
            background = md_theme_light_background,
            onBackground = md_theme_light_onBackground,
            surface = md_theme_light_surface,
            onSurface = md_theme_light_onSurface,
            surfaceVariant = md_theme_light_surfaceVariant,
            onSurfaceVariant = md_theme_light_onSurfaceVariant,
            outline = md_theme_light_outline,
            outlineVariant = md_theme_light_outlineVariant,
            scrim = md_theme_light_scrim,
            inverseSurface = md_theme_light_inverseSurface,
            inverseOnSurface = md_theme_light_inverseOnSurface,
            inversePrimary = md_theme_light_inversePrimary,
            surfaceDim = md_theme_light_surfaceDim,
            surfaceBright = md_theme_light_surfaceBright,
            surfaceContainerLowest = md_theme_light_surfaceContainerLowest,
            surfaceContainerLow = md_theme_light_surfaceContainerLow,
            surfaceContainer = md_theme_light_surfaceContainer,
            surfaceContainerHigh = md_theme_light_surfaceContainerHigh,
            surfaceContainerHighest = md_theme_light_surfaceContainerHighest,
        )
    }
}
